import {useCallback, useEffect, useState} from 'react'
import {createContainer} from "unstated-next"
import {isAnsel} from '../../utils/common'

function usePaymentDetails({
                               setCreditCardData,
                               setBankAccountData,
                               setAutoPayData,
                               setPaymentDetailsLoading,
                               getBillingInfo,
                               initialAutoPay,
                               useGroupTypeAutoPayFlow,
                               stripePaymentError,
                               setStripePaymentError,
                               setIsCreditCardFormDisplayed,
                               setMicroDepositsBankAccountData,
                               bankAccount,
                               microDepositsBankAccount,
                           }) {
    const [creditCardPmVisibility, setCreditCardPmVisibility] = useState(false)
    const [bankAccountPmData, setBankAccountPmData] = useState(null)
    const [microDepositsBankAccountPmData, setMicrodepositsBankAccountPmData] = useState(null)
    const [autoPayBtn, setAutoPayBtn] = useState(initialAutoPay)
    const [paperCheckInstructionsVisibility, setPaperCheckInstructionsVisibility] = useState(false)
    const [paperCheckConfirmationVisibility, setPaperCheckConfirmationVisibility] = useState(false)
    const [paymentDailsCardLoading] = useState(false)

    const [isCcCardNumberEmpty, setIsCcCardNumberEmpty] = useState(true);
    const [isCcExpirationEmpty, setIsCcExpirationEmpty] = useState(true);
    const [isCcCVCEmpty, setIsCcCVCEmpty] = useState(true);
    const [ccInputError, setCcInputError] = useState(isAnsel() ? {
        cardNumber: { error: false },
        cardExpiry: { error: false },
        cardCvc: { error: false},
    } : false);
    const [isCreditCardSetted, setIsCreditCardSetted] = useState(false);
    const [isPmSelected, setIsPmSelected] = useState(false);
    const [verificationStatus, setVerificationStatus] = useState("");
    const [addPaymentMethodError, setAddPaymentMethodError] = useState("");

    const setBankAccountPm = useCallback((data) => {
        data.id = data.id ? data.id : data.stripeId
        setBankAccountPmData(data)
        setBankAccountData({paymentMethodId: data.id})
        setCreditCardData(null)
    }, [setBankAccountData, setCreditCardData])

    const setMicroDepositsBankAccountPm = useCallback((data) => {
        setMicroDepositsBankAccountData(data);
        setMicrodepositsBankAccountPmData(data);
        setBankAccountPmData(null);
        setBankAccountData(null);
        setCreditCardData(null);
    }, [setBankAccountData, setCreditCardData, setMicroDepositsBankAccountData])

    useEffect(()=>{
        if(bankAccount){
            setBankAccountPm(bankAccount)
        }
    },[bankAccount, setBankAccountPm])

    useEffect(()=>{
        setMicroDepositsBankAccountPm(microDepositsBankAccount)
    }, [microDepositsBankAccount, setMicroDepositsBankAccountPm])

    const showCreditCardPm = () => {
        setIsCreditCardFormDisplayed(true);
        setCreditCardPmVisibility(true);
    }

    const hideCreditCardPm = () => {
        setIsCreditCardFormDisplayed(false);
        setCreditCardPmVisibility(false);
        setIsCcCardNumberEmpty(true);
        setIsCcExpirationEmpty(true);
        setIsCcCVCEmpty(true);
        setStripePaymentError(null);
        removePm();
    }

    useEffect(()=>{
        if(microDepositsBankAccountPmData){
            switch (microDepositsBankAccountPmData.status) {
                case "verification_failed":
                    setVerificationStatus("Unable to verify")
                    break
                case "pending_manual_verification":
                    setVerificationStatus("Pending verification")
                    break
                case "manually_verified":
                    setVerificationStatus("Verified")
                    break
                default:
                    setVerificationStatus(microDepositsBankAccountPmData.status)
                    break
            }
        }
    },[microDepositsBankAccountPmData])



    const toggleAutoPay = () => {
        const toggled = !autoPayBtn
        setAutoPayBtn(toggled)
        setAutoPayData(toggled)
    }

    const isBankAccountSelected = useCallback(() => {
        return !!bankAccountPmData
    }, [bankAccountPmData])

    const isMicroDepositsAccountSelected = useCallback(() => {
        return !!microDepositsBankAccountPmData
    }, [microDepositsBankAccountPmData])

    useEffect(() => {
        const hasError = isAnsel() ? Object.values(ccInputError).some((fieldState) => fieldState.error) : ccInputError;
        setIsCreditCardSetted(!hasError && !isCcCardNumberEmpty && !isCcExpirationEmpty && !isCcCVCEmpty);
    }, [ccInputError, isCcCardNumberEmpty, isCcExpirationEmpty, isCcCVCEmpty]);

    useEffect(() => {
        const isElectronicPaymentMethod = isCreditCardSetted || isBankAccountSelected() || isMicroDepositsAccountSelected()
        setIsPmSelected(isElectronicPaymentMethod);
        setAddPaymentMethodError("");
    }, [bankAccountPmData, isBankAccountSelected, isCreditCardSetted, isMicroDepositsAccountSelected, microDepositsBankAccountPmData]);

    const isBankAccountPmSelected = () => {
        return !!bankAccountPmData || !!microDepositsBankAccountPmData
    }

    const removePm = () => {
        setCreditCardData(null);
        setBankAccountData(null);
        setBankAccountPmData(null);
        setMicroDepositsBankAccountData(null);
        setMicrodepositsBankAccountPmData(null);
        setAddPaymentMethodError(null);
    }

    const showPaperCheckInstrucions = () => {
        setPaperCheckInstructionsVisibility(true)
    }

    const hidePaperCheckInstructions = () => {
        setPaperCheckInstructionsVisibility(false)
    }

    const showPaperCheckConfirmation = () => {
        setPaperCheckConfirmationVisibility(true)
    }

    const hidePaperCheckConfirmartion = () => {
        setPaperCheckConfirmationVisibility(false)
    }

    const setPlaidData = (metadata) => {
        setBankAccountPm(metadata)
    }

    const setMicroDepositsPlaidData = (metadata) => {
        setMicroDepositsBankAccountPm(metadata)
    }

    const showPaymentDetailsCardLoading = (value) => {
        setPaymentDetailsLoading(value)
    }

    return {
        creditCardPmVisibility,
        showCreditCardPm,
        hideCreditCardPm,
        setBankAccountPm,
        removePm,
        bankAccountPmData,
        microDepositsBankAccountPmData,
        isPmSelected,
        isBankAccountPmSelected,
        toggleAutoPay,
        autoPayBtn,
        useGroupTypeAutoPayFlow,
        paperCheckInstructionsVisibility,
        showPaperCheckInstrucions,
        hidePaperCheckInstructions,
        paperCheckConfirmationVisibility,
        showPaperCheckConfirmation,
        hidePaperCheckConfirmartion,
        setPlaidData,
        setMicroDepositsPlaidData,
        showPaymentDetailsCardLoading,
        paymentDailsCardLoading,
        setIsCcCardNumberEmpty,
        setIsCcExpirationEmpty,
        setIsCcCVCEmpty,
        setCcInputError,
        ccInputError,
        stripePaymentError,
        setStripePaymentError,
        setIsCreditCardFormDisplayed,
        isCreditCardSetted,
        isMicroDepositsAccountSelected,
        setMicroDepositsBankAccountPm,
        getBillingInfo,
        verificationStatus,
        setVerificationStatus,
        addPaymentMethodError,
        setAddPaymentMethodError,
    }
}

export const PaymentDetails = createContainer(usePaymentDetails);
